import { render, staticRenderFns } from "./Tableheader.vue?vue&type=template&id=d436b6a0&scoped=true&"
import script from "./Tableheader.vue?vue&type=script&lang=js&"
export * from "./Tableheader.vue?vue&type=script&lang=js&"
import style0 from "./Tableheader.vue?vue&type=style&index=0&id=d436b6a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d436b6a0",
  null
  
)

export default component.exports